// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2eCb2","right":"styles_right__2UDFh"};